import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const controllerPath = `${BASE_PATH_API}/financials`;

const actions = {
    getNetIncomeSummaryForAccount: {
        method: 'GET',
        url: `${controllerPath}/company/:id/netincomesummary/:startDate/:endDate`
    },
    getNetIncomeDetailsForAccount: {
        method: 'GET',
        url: `${controllerPath}/company/:id/netincome/:startDate/:endDate/details`
    },
    getNetIncomeCategoriesForAccount: {
        method: 'GET',
        url: `${controllerPath}/company/:id/netincome/:startDate/:endDate`,
        isArray: true
    },
    getFinancials: {
        method: 'POST',
        url: `${controllerPath}`,
        isArray: true
    }
};

export function FinancialsApi() {
    return createActions(actions);
}
